import { render } from "./LaneNumbers.vue?vue&type=template&id=2233ac1c&scoped=true"
import script from "./LaneNumbers.vue?vue&type=script&lang=js"
export * from "./LaneNumbers.vue?vue&type=script&lang=js"

import "./LaneNumbers.vue?vue&type=style&index=0&id=2233ac1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2233ac1c"]])

export default __exports__